import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'gray';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    gray: 'bg-neutral-50'
  };
  return <section id={id} className={`py-20 md:py-32 ${backgrounds[background]} ${className}`} data-id="element-352">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl" data-id="element-353">{children}</div>
    </section>;
}